import { GetApPayeesMacro200ResultItem } from 'ap-openapi';

interface StringRecord {
  [key: string]: string;
}

/**
 * Replaces all macro patterns ${key} in the input text with their corresponding values
 * and encodes newlines for proper PDF rendering
 * @param text The input text containing macro patterns to replace
 * @param macros Array of macro definitions with before/after values
 * @returns The text with all macros replaced and newlines encoded
 */
export const replaceMacros = (
  text: string,
  macros: GetApPayeesMacro200ResultItem[]
): string => {
  if (!text) return '';

  // Create a map for quick lookup and compile regex once
  const macroMap: StringRecord = Object.fromEntries(
    macros.map(({ before, after }) => [before, after || ''])
  );
  const macroRegex = /\${(.*?)}/g;

  // Replace all macros in the text
  const result = text.replace(
    macroRegex,
    (_, key: string) => macroMap[key] ?? `\${${key}}`
  );

  return result;
};
